import React from "react";

export default function SQLServer_COT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_COT</h1>
      <p>This is the SQLServer_COT component generated from the SQL JSON.</p>
    </div>
  );
}
